import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';

import type IRegulationHorizonProps from './interfaces/IRegulationHorizonProps';

import styles from './sass/RegulationHorizon.module.scss';

function RegulationHorizon({ horizons }: IRegulationHorizonProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.regulationTimeline}>
      <div className={styles.regulationTimelineLabel}>
        {t('launchpad.indicatorsPanel.impactHorizon')}
      </div>
      <div className={styles.horizons}>
        {horizons.map((horizon, index) => (
          <div
            key={horizon.monthsI18nKey}
            className={clsx(styles.horizon, {
              [styles.active]: index === horizons.length - 1,
            })}
          >
            <span className={styles.months}>{t(horizon.monthsI18nKey)}</span>
            <span className={styles.count}>{horizon.count}</span>
            <span className={styles.sub}>{t('launchpad.indicatorsPanel.impacts')}</span>
            <div className={styles.bar}>
              <span
                className={styles.barFill}
                style={{ width: `${horizon.pct}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RegulationHorizon;
